import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService, Language } from './../../language.service';
@Component({
  selector: 'app-font-size',
  templateUrl: './font-size.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FontSizeComponent  implements OnInit {
  language$: Observable<Language>;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.language$ = this.languageService.getLanguage();
  }
  
  toggle() {
    if(this.isLarge()) {
      this.normal();
    } else {
      this.large();
    }
  }
  normal() {
    (document.querySelector(":root") as HTMLElement)?.style.setProperty('--font-zoom', '1');
  }  
  large() {
    (document.querySelector(":root") as HTMLElement)?.style.setProperty('--font-zoom', '1.5');
  }

  isLarge() {
    return (document.querySelector(":root") as HTMLElement)?.style.getPropertyValue('--font-zoom') === '1.5';
  }

  smallClass() {
    if(this.isLarge()) {
      return "";
    } else {
      return "global-button__activated";
    }
  }

  largeClass() {
    if(this.isLarge()) {
      return "global-button__activated";
    } else {
      return "";
    }
  }

  title(language: Language): string {
    if(this.isLarge()) {
      if(language === 'en') {
        return "Decrease font size";
      } else {
        return "Schriftgröße verringern";
      }    
    } else {
      if(language === 'en') {
        return "Increase font size";  
      } else {
        return "Schriftgröße erhöhen";
      }
    }
  }
}
